/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import { StyledCircularLoader } from "./styles";

export const CircularSkeletalLoader = ({ dataTestId }) => {

  return (
    <StyledCircularLoader 
      variant="circular" 
      animation="wave"
      data-testid={dataTestId}
    />
  )
}
